<template>
  <v-container fluid class="pa-0">
    <v-row v-if="!loading" justify="center">
      <v-col cols="12">
        <CustomerOrSupplier :entitys="entitys" :type="1" @update="getData" />
      </v-col>
    </v-row>
    <v-row justify="center" v-else>
      <v-col cols="12" md="10">
        <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions">
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerOrSupplier from "../../components/Accounting/CustomerOrSupplier.vue";
export default {
  name: "ContactsView",
  components: { CustomerOrSupplier },
  data: () => ({
    loading: false,
    entitys: [],
  }),
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      let resultEntity = await this.api_Get("accounting/entity_all/3");
      this.entitys = await resultEntity.json();
      this.loading = false;
    },
  },
};
</script>

<style></style>
